import React, { useEffect, useState } from "react";
import "./style.css";
const GoldPrice = () => {
    useEffect(() => {
        setTimeout(() => {
            document
                .querySelector("iframe")
                .contentWindow.document.querySelector(".watermark");
        }, 6000);
    }, []);
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);

    return (
        <div
            style={{ padding: "-17px", background: "rgb(36 36 36 / 96%)" }}
            class="goldprice"
        >
            <h1>
                <span>{lang === "Fr" ? `PRIX DE ` : `Gold`}</span>{" "}
                {lang === "Fr" ? `L’OR` : `Price`}
            </h1>
            <iframe
                src="https://goldbroker.com/widget/historical/XAU?height=500&currency=USD"
                scrolling="no"
                frameborder="0"
                width="100%"
                height="580"
                className="iframe-gold-price"
            ></iframe>
            <div class="watermark">GOLD BAR</div>
            <div class="g-list"></div>
        </div>
    );
};

export default GoldPrice;
